export default class Storage {
  constructor (defaults = {}) {
    // Load all Defaults to the localStorage
    Object.keys(defaults).forEach((key) => {
      localStorage[key] = defaults[key]
    })
  }

  has (key) {
    return (localStorage[key] !== undefined)
  }

  get (key) {
    if (this.has(key)) {
      return localStorage[key]
    }
    return null
  }

  set (key, value) {
    localStorage.setItem(key, value)
  }

  clear (key) {
    localStorage.clear(key)
  }

  getJSON (key) {
    if (this.has(key)) {
      return this.parseJSON(localStorage[key])
    }
    return null
  }

  putJSON (key, value) {
    this.set(key, JSON.stringify(value))
  }

  parseJSON (value) {
    // Check if value is not undefined
    if (typeof value === 'undefined') { return null }

    // Check if value is JSON Object
    if (typeof value === 'object') { return value }

    try {
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  }
}
